import Abstract from '../../../framework/Abstract';

import './text-module.scss';

class TextModule extends Abstract {
	init() {
		// console.log('[Text Module Mounted]', { config: this.config });
	}
}

export default TextModule;
